import { i18n } from "@frontend/i18n";
import { resolveLocale } from "@frontend/shared/infrastructure/i18n/i18n-locale-resolver";

const locale = resolveLocale();
i18n.setLocale(locale);

// index.html hardcodes lang="en", but this app renders in whichever locale it
// just resolved. Assistive tech takes pronunciation from this attribute.
document.documentElement.lang = locale;
